import { render, staticRenderFns } from "./sample-request.vue?vue&type=template&id=dd211ba6&"
import script from "./sample-request.vue?vue&type=script&lang=js&"
export * from "./sample-request.vue?vue&type=script&lang=js&"
import style0 from "./sample-request.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports